
<template>
    <div>
      <lk-modal v-model="showModal" width="420">
        <p slot="header">
          <span>预收退款</span>
        </p>
        <lk-form
          :model="refundData"
          label-position="right"
          :label-width="90"
          ref="refundData"
          :rules="ruleValidate">
          <div ref="approvalIdea">
            <lk-form-item label="退款单号：">
              <span>{{refundId}}</span>
            </lk-form-item>
            <lk-form-item label="退款方式：" prop="method">
                <lk-select v-model="refundData.method" label-in-value @on-change="handleProceedsTypeChange">
                    <lk-option v-for="item in proceedsTypeList" :value="item.proceedsTypeId" :key="item.proceedsTypeId">{{ item.proceedsTypeName }}
                    </lk-option>
                </lk-select>
            </lk-form-item>
            <lk-form-item label="退款金额：" prop="price">
              <lk-input :maxlength='40' placeholder='请输入' clearable v-model.trim="refundData.price" ></lk-input>
            </lk-form-item>
            <lk-form-item label="退款原因：">
              <lk-input :maxlength='40' placeholder='请输入' clearable v-model.trim="refundData.reason" ></lk-input>
            </lk-form-item>
          </div>
        </lk-form>
        <div slot="footer">
          <lk-button type="primary" size="large"  @click="handleSure">确认退款</lk-button>
          <lk-button type="default" size="large"  @click="handleCancel">取消</lk-button>
        </div>
      </lk-modal>
    </div>
</template>
<script>
import utils from '../../libs/utils';
import system from '../../services/system';

export default {
  props: {
    refundId: {
      type: String,
    },
    orderNum: {
      type: String,
    },
    status: {
      type: Boolean,
    },
  },
  model: {
    prop: 'status',
    event: 'click',
  },
  data() {
    return {
      showModal: this.status,
      proceedsTypeList: [],
      methodList: [{ name: '广发', value: 1 }, { name: '支付宝', value: 2 }],
      refundData: {},
      ruleValidate: {
        method: [
          {
            required: true,
            message: '请选择退款方式',
            trigger: 'blur',
          },
        ],
        price: [
          {
            required: true,
            message: '请输入退款金额',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    handleSure() {

    },
    handleCancel() {
      this.status = false;
    },
    getProceedsTypeList() {
      system.getStoreProceedsTypeList({ status: 1 }).then((res) => {
        if (res.status === 200) {
          this.proceedsTypeList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleProceedsTypeChange(item) {
      this.refundData.proceedsTypeName = item.label; // 退款方式名称
    },
  },
  mounted() {
    this.getProceedsTypeList();
  },
  watch: {
    status: {
      handler(val) {
        this.showModal = val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>